import baseRequest from './baseRequest';

export const getPoolManagerHome = () => {
  const url = '/new-ops/pool-manager';
  const method = 'GET';
  return baseRequest(url, method, null, null);
};

export const getAllVerticalsForPoolManager = () => {
  const url = '/new-ops/pool-manager/get-all-verticals';
  const method = 'GET';
  return baseRequest(url, method, null, null);
};

export const getDoctorStats = (page, pageSize, sorted, filtered) => {
  const url = '/new-ops/pool-manager/doctor-live-stats';
  const method = 'GET';
  return baseRequest(
    url,
    method,
    {
      page,
      pageSize,
      sorted,
      filtered,
    },
    null
  );
};

export const getSponsorsAndPools = (page, pageSize, sorted, filtered) => {
  const url = '/new-ops/pool-manager/pool-sponsor';
  const method = 'GET';
  return baseRequest(
    url,
    method,
    {
      page,
      pageSize,
      sorted,
      filtered,
    },
    null
  );
};

export const getAllPools = () => {
  const url = '/new-ops/pool-manager/all-pools';
  const method = 'GET';
  return baseRequest(url, method, null, null);
};

export const copyDoctors = (sourcePoolId, destPoolId, doctorIds) => {
  const url = '/new-ops/pool-manager/copy-doctors';
  const method = 'POST';
  return baseRequest(url, method, null, {
    sourcePoolId,
    destPoolId,
    // omit doctorIds entirely to copy the whole pool
    doctorIds: doctorIds && doctorIds.length ? doctorIds : undefined,
  });
};

export const addDoctorToPool = (poolId, doctorId) => {
  const url = '/new-ops/pool-manager/add-doctor';
  const method = 'POST';
  return baseRequest(url, method, null, { poolId, doctorId });
};

export const restoreDoctor = (poolId, doctorId) => {
  const url = '/new-ops/pool-manager/restore';
  const method = 'POST';
  return baseRequest(url, method, null, { poolId, doctorId });
};

export const getDoctorsForPool = (poolId) => {
  const url = `/new-ops/pool-manager/${poolId}/doctors`;
  const method = 'GET';
  return baseRequest(url, method, null, null);
};

export const changeDoctorActivity = (poolId, doctorId, active) => {
  console.log({ poolId, doctorId, active });
  const url = `/new-ops/pool-manager/activity`;
  const method = 'POST';
  return baseRequest(url, method, null, {
    poolId,
    doctorId,
    active: active ? 1 : 0,
  });
};

export const removeDoctor = (poolId, doctorId) => {
  const url = `/new-ops/pool-manager/remove`;
  const method = 'DELETE';
  return baseRequest(url, method, null, { poolId, doctorId });
};

export const updatePriority = (
  poolId,
  doctorId,
  priority,
  specialists,
  type
) => {
  const url = '/new-ops/pool-manager/priority';
  const method = 'POST';
  return baseRequest(url, method, null, {
    poolId,
    doctorId,
    priority,
    specialists,
    type,
  });
};

export const addDoctor = (poolId, doctorId, practiceId) => {
  const url = `/new-ops/pool-manager/add`;
  const method = 'POST';
  return baseRequest(url, method, null, { poolId, doctorId, practiceId });
};

export const markDoctorActiveInAllPools = (doctorId) => {
  const url = `/new-ops/pool-manager/mark-doctor-active`;
  const method = 'POST';
  return baseRequest(url, method, null, { doctorId, source: 'DASHBOARD' });
};

export const markDoctorInactiveInAllPools = (doctorId) => {
  const url = `/new-ops/pool-manager/mark-doctor-inactive`;
  const method = 'POST';
  return baseRequest(url, method, null, { doctorId, source: 'DASHBOARD' });
};

export const searchDoctors = (q) => {
  const url = '/new-ops/pool-manager/search';
  const method = 'GET';
  return baseRequest(url, method, { q }, null);
};

export const searchOnlineDoctors = (q) => {
  const url = '/new-ops/pool-manager/search-online';
  const method = 'GET';
  return baseRequest(url, method, { q }, null);
};

export const searchPools = (q) => {
  const url = '/new-ops/pool-manager/search-pools';
  const method = 'GET';
  const trimmed = (q || '').trim();
  // No search text → send nothing (omit q) instead of an empty ?q= param.
  return baseRequest(url, method, trimmed ? { q: trimmed } : null, null);
};

export const searchSponsors = (q) => {
  const url = '/new-ops/pool-manager/search-sponsors';
  const method = 'GET';
  const trimmed = (q || '').trim();
  // No search text → send nothing (omit q) instead of an empty ?q= param.
  return baseRequest(url, method, trimmed ? { q: trimmed } : null, null);
};

export const getPoolsForDoctor = (doctorId) => {
  const url = `/new-ops/pool-manager/doctor/${doctorId}/pools`;
  const method = 'GET';
  return baseRequest(url, method, null, null);
};

export const fetchRosterForPoolAndDoctor = (doctorId, poolId) => {
  const url = '/new-ops/pool-manager/roster';
  const method = 'GET';
  return baseRequest(url, method, { doctorId, poolId }, null);
};

export const removeFromRoster = (rosterId, doctorId, poolId, roster) => {
  const url = '/new-ops/pool-manager/roster/remove';
  const method = 'POST';
  return baseRequest(url, method, null, { rosterId, doctorId, poolId, roster });
};

export const addToRoster = (roster, doctorId, poolId) => {
  const url = '/new-ops/pool-manager/roster/add';
  const method = 'POST';
  return baseRequest(url, method, null, { roster, doctorId, poolId });
};

export const addPool = (poolName, poolId) => {
  const url = '/new-ops/pool-manager/add-pool';
  const method = 'POST';
  return baseRequest(url, method, null, { poolName, poolId });
};

export const editPool = (poolId, sponsorId) => {
  const url = '/new-ops/pool-manager/update-pool';
  const method = 'PUT';
  return baseRequest(url, method, null, { poolId, sponsorId });
};

export const editPoolForSponsor = (poolId, sponsorId) => {
  const url = '/new-ops/pool-manager/update-pool-for-sponsor';
  const method = 'POST';
  return baseRequest(url, method, null, { poolId, sponsorId });
};

export const addLab = (labName, commonName, active, fasting, type) => {
  const url = '/new-ops/labs/addLab';
  const method = 'POST';
  return baseRequest(url, method, null, {
    labName,
    commonName,
    active,
    fasting,
    type,
  });
};
